[
  {
    "locale": "nl-NL",
    "longName": "Nederlands",
    "shortName": "NL",
    "icon": "NL"
  },
  {
    "locale": "en-GB",
    "longName": "English",
    "shortName": "EN",
    "icon": "GB"
  }
]
